import { createTheme } from "@mui/material/styles";

const skidattlTheme = createTheme({
  spacing: 4,
  typography: {
    fontFamily: 'var(--body-font)',
  },
  palette: {
    primary: {
      main: "#FF671F",
      // light and dark variants are generated automatically.
    },
    secondary: {
      main: "#FC7535",
      // light and dark variants are generated automatically.
    },
    background: {
      paper: '#EEEEEE',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          textTransform: 'none',
          letterSpacing: '0.01em',
        },
        sizeLarge: {
          padding: '15px 14px',
        },
        contained: {
          color: '#FFFFFF',
          backgroundColor: 'var(--action-primary)',
          '&:hover' : {
            backgroundColor: 'var(--action-primary-hover)',
          }
        }
      }
    }
  }
});

export { skidattlTheme };